// extracted by mini-css-extract-plugin
module.exports = {"efAppPCG":"G_efAppPCG__8z9fc"};